const actions = {
  RESET_ITEMS: 'SETTINGS_RESET_ITEMS',
  LOAD_ITEMS: 'SETTINGS_LOAD_ITEMS',
  LOAD_ITEMS_SUCCESS: 'SETTINGS_LOAD_ITEMS_SUCCESS',
  UPDATE_ITEM_SAGA: 'SETTINGS_UPDATE_ITEM_SAGA',
  loadSettings: (params) => ({ type: actions.LOAD_ITEMS, params }),
  updateSettings: (params) => ({ type: actions.UPDATE_ITEM_SAGA, params }),
};
export default actions;
